// простая проверка на число
export function isNumber(value: any) {
  return typeof value === 'number' && isFinite(value);
}

function isNumberObject(value: any) {
  return Object.prototype.toString.apply(value) === '[object Number]';
}

export function isCustomNumber(value: any) {
  return isNumber(value) || isNumberObject(value);
}

export function isString(value: any) {
  return typeof value === 'string' || value instanceof String;
}

export function replaceAt(str: string, index: number, replacement: string) {
  return str.substring(0, index) + replacement + str.substring(index + replacement.length);
}
